import { fetchInterceptor } from '../commons/Interceptor'
import { getBaseURL, getAPIKey, getToken } from '../environment'

const endpoint = 'news'
const apiKey = getAPIKey()

export const getSources = async filter => {
    const url = `${getBaseURL()}/${endpoint}/sources`
    const queryParams = new URLSearchParams(filter)

    try {
        const response = await fetch(`${url}?${queryParams.toString()}`, {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${getToken()}`,
            },
        })
        return await response.json()
    } catch (err) {
        console.error('Erro: ', JSON.stringify(err))
        throw err
    }
}

export const getNotifications = async () => {
    const url = `${getBaseURL()}/${endpoint}/notifications`
    const queryParams = new URLSearchParams({ source: 'Portal' })

    try {
        const response = await fetch(`${url}?${queryParams.toString()}`, {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${getToken()}`,
            },
        })
        return await response.json()
    } catch (err) {
        console.error('Erro: ', JSON.stringify(err))
        throw err
    }
}

export const getNotificationsConfig = async () => {
    const url = `${getBaseURL()}/${endpoint}/notificationConfig`

    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${getToken()}`,
            },
        })
        return await response.json()
    } catch (err) {
        console.error('Erro: ', JSON.stringify(err))
        throw err
    }
}

export const updateNotificationsConfig = async notificationConfig => {
    try {
        const url = `${getBaseURL()}/${endpoint}/notificationConfig`
        const response = await fetch(url, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${getToken()}`,
            },
            body: JSON.stringify(notificationConfig),
        })
        if (response.status > 299 || response.status < 200)
            throw new Error(await response.text())

        return await response.json()
    } catch (err) {
        console.error('Erro: ' + err.message)
        throw err
    }
}

export const getAllVersions = () => {
    const url = `${getBaseURL()}/${endpoint}/versions/`
    const queryParams = new URLSearchParams({ deleted: false, published: true })

    return fetchInterceptor(`${url}?${queryParams.toString()}`, {
        method: 'GET',
        headers: {
            'x-api-key': apiKey,
            Authorization: `Bearer ${getToken()}`,
        },
    })
        .then(response => response.json())
        .catch(err => {
            console.error('Erro: ', JSON.stringify(err))
            throw err
        })
}
